import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.833 4.833a.75.75 0 0 0-.75.75v12.833c0 .415.336.75.75.75H17.5a.75.75 0 0 0 .75-.75v-3.312l2.433 2.053a.75.75 0 0 0 1.234-.573V7.417a.75.75 0 0 0-1.234-.573L18.25 8.897V5.583a.75.75 0 0 0-.75-.75zm.75 12.833V6.333H16.75v11.333zm14.667-4.525V10.86l2.167-1.828v5.939z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.216 9.228a.75.75 0 0 1 1.056-.096l2.75 2.292a.75.75 0 0 1 0 1.152l-2.75 2.291a.75.75 0 1 1-.96-1.152L10.37 12l-2.058-1.716a.75.75 0 0 1-.096-1.056",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }